module.exports = __webpack_public_path__ + "static/media/Group1673.c5b43b91.svg";